import * as React from "react";
import { createRoot } from "react-dom/client";
import { WageCalculator } from '@elo-ds/ui/dist/WageCalculator';

const renderWageCalculator = () => {
    const container = document.getElementById('wage-calculator-wrapper');
    const apiUrl = "/api/WageCalculatorAPI/Calculate";
    const apiCompareUrl = "/api/WageCalculatorAPI/Compare";
    const securityContainer = document && document.getElementsByClassName("security-container")[0];

    var requestVerificationToken = null;
    if (securityContainer) {
        requestVerificationToken = securityContainer.getElementsByTagName("input")[0].value;
    }

    if (container) {
        const wageCalculatorData = container.getAttribute("data-json");

        let object = JSON.parse(wageCalculatorData);
        object.requestVerificationToken = requestVerificationToken;
        object.apiUrl = apiUrl;
        object.apiCompareUrl = apiCompareUrl;

        createRoot(container).render(
            <WageCalculator
                {...object}
            />
        );
    }
};
renderWageCalculator();